import { render } from "./CalendarTimeGrid.vue?vue&type=template&id=671fa5eb"
import script from "./CalendarTimeGrid.vue?vue&type=script&lang=js"
export * from "./CalendarTimeGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__